export default "__VITE_ASSET__AH57IyUT__"